import { Navigate, Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { authStore } from "../../store/AuthStore";

interface RoleBasedRouteProps {
    requiredRole?: 'super' | 'user';
    fallbackPath?: string;
}

const RoleBasedRoute = observer(({ 
    requiredRole = 'user', 
    fallbackPath = '/login' 
}: RoleBasedRouteProps) => {
    const user = authStore.user;
    
    // 사용자가 로그인하지 않은 경우
    if (!user) {
        return <Navigate to={fallbackPath} replace />;
    }
    
    // SuperUser 권한이 필요한 경우
    if (requiredRole === 'super' && !user.isSuperUser) {
        return <Navigate to="/" replace />;
    }
    
    // 권한이 충족된 경우
    return <Outlet />;
});

export default RoleBasedRoute;
